import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { RootState, useAppDispatch, useAppSelector } from "../../../state/state.tsx";
import { closeModal, openModal, toggleLoading } from "../../../state/ModalSlice/ModalSlice.ts";
import { getFutureCycles } from "../utilityFunctions.ts";
import { useBackend } from "../../../hooks/backend/useBackend.ts";
import { CircularProgress, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { setFieldsForPauseErrorModal } from '../../../state/ArbitrarySlice/ArbitratySlice.ts';
import { toast } from 'react-toastify';
import { collection, query, where, getDocs, Timestamp } from 'firebase/firestore';
import { db } from '../../../Config/firebase.ts';
import { selectEffectiveUID } from '../../../state/UserStatesV2/userSliceV2.ts';    

export default function PauseLiveSubscription() {


    // Selectors
    const ServiceProviderID = useAppSelector(selectEffectiveUID) 
    const LiveSubs = useAppSelector((state: RootState) => state.LiveSubscriptionSlice.data)
    const selectedLiveSubId = useAppSelector((state: RootState) => state.ArbitrarySlice.ForPauseLiveSubscriptionModal.LiveSubscriptionId)
    const subcriptionId = useAppSelector((state: RootState) => state.ArbitrarySlice.ForPauseLiveSubscriptionModal.subscriptionId)
    const selectedLiveSub = LiveSubs ? LiveSubs.filter((data) => data.id === selectedLiveSubId)[0] : null
    const isLoading = useAppSelector((state: RootState) => state.ModalSlice.isLoading)

    // States
    const Dispatch = useAppDispatch();
    const open = useAppSelector((state: RootState) => state.ModalSlice.PauseLiveSubscriptionModalOpen);
    const futureCycles = getFutureCycles().slice(0, 3)

    // Modal Handling
    function handleClose() {
        Dispatch(closeModal("PauseLiveSubscriptionModalOpen"))
    }
    async function queryExistingOrders() {
        if (selectedLiveSub && selectedLiveSub.invoiceCycleList) {
            // console.log("selectedLiveSub.invoiceCycleList", selectedLiveSub)
            // Loop through futureCycles
            if (selectedLiveSub.invoiceCycleList.includes(futureCycles[0])) {

                const ordersRef = collection(db, `ServiceProviders/${ServiceProviderID}/Orders`)
                // Check if any order is pending
                const querySnapshot = await getDocs(query(ordersRef,
                    where('cycleName', '==', futureCycles[0]),
                    where('livesubscriptionId', '==', selectedLiveSubId),
                    where('orderType', '!=', 'writeoff')
                ));
                          

                if (!querySnapshot.empty) {
                    const doc = querySnapshot.docs[0];
                    if (doc.data().payment_status === 'Pending') {
                        return true;
                    }
                }
            }

        }
        return false
    }

    function handleErrorModalOpening() {
        Dispatch(setFieldsForPauseErrorModal({ LiveSubscriptionId: selectedLiveSubId, SubscriptionId: subcriptionId, orderMonth: futureCycles[0] }))
        Dispatch(toggleLoading(false))
        Dispatch(openModal("PauseErrorModalOpen"))
    }

    const { update, updateArrayField } = useBackend(`/ServiceProviders/${ServiceProviderID}/LiveSubscriptions`)

    async function onSubmit(e: any) {
        // Dispatch(toggleLoading(true))
        e.preventDefault()
        const queryResponse = await queryExistingOrders()
        if (queryResponse === true) {
            handleErrorModalOpening()
        } else {
            try {
                update(selectedLiveSubId, { status: "Paused", updatedAt: Timestamp.fromDate(new Date()) })
                updateArrayField(selectedLiveSubId, "pauseHistory", { pauseTS: Timestamp.now() })
                toast.success("student Paused Successfully")
            } catch (error) {
                toast.error("Error Pausing student")
            }

        }
        Dispatch(toggleLoading(false))
        handleClose()
        return
    }

    return (<React.Fragment>

        <Dialog
            sx={{
                padding: 0,
                '& .MuiPaper-root': {
                    borderRadius: '16px',
                },
            }}
            maxWidth="md"
            open={open}

            PaperProps={{
                component: 'div',
            }}
        >
            <DialogContent sx={{ paddingX: "60px", paddingY: "50px" }} className={"bg-white"}>
                <div className={"header pb-[20px] w-[550px]"}>
                    <p className={"text-cf_heading font-[600] "}>Pause Student</p>
                </div>

                <div className={"absolute right-4 top-4"}><IconButton onClick={handleClose}>
                    <CloseIcon />
                </IconButton></div>

                <div className={"pt-0 flex flex-col gap-2"}>
                    <div>
                        <p>Are you sure you want to pause this student?</p>
                        <p className='text-sm font-semibold mt-2'>Note: student will remain paused until you resume it.</p>
                    </div>

                </div>

                <div className={"flex gap-2 pt-8"}>
                    <button onClick={(e) => {
                        e.preventDefault();
                        handleClose()
                    }} disabled={isLoading}
                        className={`w-full bg-cc_bg-tertiary border border-solid border-gray-500 p-1.5 rounded-lg ${isLoading ? "cursor-not-allowed" : "cursor-pointer"}`}>Cancel
                    </button>
                    <button
                        onClick={onSubmit} disabled={isLoading}
                        className={`w-full bg-cc_brand text-white p-1.5 rounded-lg border-gray-500 flex justify-center items-center ${isLoading ? "cursor-not-allowed" : "cursor-pointer"}`}>{isLoading &&
                            <CircularProgress sx={{ color: "white" }} size={20} />}
                        <p className={"ml-2"}>{isLoading ? "Loading" : "Confirm"}</p>
                    </button>

                </div>
            </DialogContent>

        </Dialog>

    </React.Fragment>);
}